import { HighestConversionCampaign } from '../../domain';
import { Row } from './Row';
import { TableWrapper } from './TableWrapper';
import { HIGHEST_CONVERSIONS_CAMPAIGNS_TABLES_LENGTH } from '../constants';

export const HIGHEST_CAMPAIGN_CONVERSIONS_DATA_TEST = 'highest-campaign-conversions-table';

type TableProps = {
  values: HighestConversionCampaign[];
};

export const Table = ({ values }: TableProps) => {
  const highestConvertingCampaigns = values.slice(0, HIGHEST_CONVERSIONS_CAMPAIGNS_TABLES_LENGTH);
  const reformatHighestConvertingCampaigns = highestConvertingCampaigns.map(
    ({ campaign: { id, name }, conversionRate }) => ({
      id,
      name,
      conversionRate,
    }),
  );

  return (
    <TableWrapper data-test={HIGHEST_CAMPAIGN_CONVERSIONS_DATA_TEST}>
      {reformatHighestConvertingCampaigns.map(({ id, name, conversionRate }, i) => (
        <Row
          campaignId={id}
          campaignName={name}
          conversionRate={conversionRate}
          key={`${id}-${name}`}
          rowIndex={i}
        />
      ))}
    </TableWrapper>
  );
};
